export default __webpack_public_path__ + "47d227801c1ad6c59d033bc151848c07.png";